import { gql } from '@apollo/client';

const IS_POSTAL_CODE_VALID_QUERY = gql`
  query isPostalCodeValid($input: CheckPostalCodeInput!) {
    isPostalCodeValid(input: $input)
  }
`;

export default IS_POSTAL_CODE_VALID_QUERY;
